import ReactDOM from "react-dom/client";
import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";
import Select from "react-select";
import NotificationEventTypes from "../../constants/notificationEventsEnum";
function CampusNewRegistrationModel({
  onClose,
  firstRegistrationId,
  refreshOnSubmitSuccess,
}) {
  const token = localStorage.getItem("token");

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    getValues,
    handleSubmit,
  } = useForm({
    defaultValues: {
      interviewDate: "",
      assessmentSlotId: null,
      reason: "",
      remarks: "",
      createdBy: localStorage.getItem("userId"),
      updatedBy: localStorage.getItem("userId"),
    },
  });

  const NewRegistration = async (data) => {
    const formData = {
      email: getValues("email"),
      firstName: data.firstName,
      lastName: data.lastName,
      organizationId: localStorage.getItem("organizationId"),
      centerId: localStorage.getItem("centerId"),
      FormId: 22,
      NotificationEventTypeIds: NotificationEventTypes.ADD.toString(),
    };

    try {
      const response = await post("User/CampusGuardianRegistration", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      refreshOnSubmitSuccess(response.userId);
    } catch (error) {
      console.error("Error In New Registration", error);
    }
  };

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="mb-0">Guardian Registration</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <form
                className="row g-3 new-form-style"
                onSubmit={handleSubmit(NewRegistration)}
              >
                <div className="col-md-12">
                  <label className="form-label form-label-new">
                    Email Address<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register(`email`, {
                      required: "This field is required.",
                    })}
                    className="form-control"
                  ></input>
                  {errors.email && (
                    <small className="text-danger">
                      {errors.email.message}
                    </small>
                  )}
                </div>
                <div className="col-6">
                  <label className="form-label form-label-new">
                    First Name <span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register("firstName", {
                      required: "This field is required.",
                    })}
                    type="text"
                    className="form-control form-icon-input"
                  />
                  {errors.email && (
                    <small className="text-danger">
                      {errors.email.message}
                    </small>
                  )}
                </div>
                <div className="col-6">
                  <label className="form-label form-label-new">
                    Last Name <span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register("lastName", {
                      required: "This field is required.",
                    })}
                    type="text"
                    className="form-control form-icon-input"
                  />
                  {errors.email && (
                    <small className="text-danger">
                      {errors.email.message}
                    </small>
                  )}
                </div>

                <div className="d-flex gap-2 justify-content-end">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <span
                        className="spinner-border spinner-custom-size me-1"
                        aria-hidden="true"
                      ></span>
                    ) : null}
                    <span role="status">Next</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default CampusNewRegistrationModel;
